<script>
	import { getContext, onDestroy } from 'svelte'
	import GRS from '../components/GRS.svelte';
	import GrsDevices from './grsDevices';
	import * as map from '../map'

	const flight = getContext('flight')
	const markers = flight.getHandler(GrsDevices)

	const layer = L.layerGroup()
	layer.addTo(map.getMap())
	const overlay = map.addOverlay("GRS", layer, flight.overlay)

	onDestroy(() => {
		layer.removeFrom(map.getMap())
		map.removeOverlay(overlay, flight.overlay)
	})
</script>

{#each Object.values($markers).filter(m => m.type == 'GRS') as device (device.id)}
	<GRS active {device} {layer} />
{/each}